import { styled, Typography, Box } from '../../../base'; // Assuming styled is from base

export const CreateCompanyModalWrapper = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    // gap removed, spacing will be handled by child margins
}));

// Renamed and restyled for clarity and purpose as the main custom title
export const CustomModalHeader = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    paddingBottom: theme.spacing(2),
    // variant (e.g., h6) will be applied in the component usage
    // Color will be default (primary text) unless specified, which matches the image better
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
    marginTop: theme.spacing(0.5), // Small space after the CustomModalHeader
    marginBottom: theme.spacing(2), // Space before the FormContainer
}));

export const FormContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
}));

export const ButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
});
